import {TranslationObject} from '@colonist/i18n'
import {Sound} from '../Sound'
import {ViewPopup} from './ViewPopup'

export class ViewPopupStoreLink extends ViewPopup {
    private static readonly colorStoreLink = '/store#colors'

    constructor(title: TranslationObject, body: TranslationObject) {
        super(title, body, () => undefined, () => undefined, true)

        this.checkButton.id = 'store-href'
        this.checkButton.onclick = () => {
            Sound.playSound(Sound.SoundType.Click)
            this.removePopup()
            ViewPopupStoreLink.openStoreLink()
        }
        this.show()
    }

    private static openStoreLink() {
        const link = document.createElement('a')
        link.href = ViewPopupStoreLink.colorStoreLink
        link.target = '_blank'
        link.style.display = 'none'
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
    }
}
